module.exports = __webpack_public_path__ + "static/media/calculator-alt.d1e73a41.svg";